import React from 'react';
import StyledButton from '@src/components/wysiwyg_editor/page_content_items/control_panels/StyledButton';
import zoomImg from '@images/wysiwyg_editor/control_panels/zoom.svg';
import zoomHoverImg from '@images/wysiwyg_editor/control_panels/zoom-hover.svg';

type TProps = {
  onClick: () => void;
};

function Zoom(props: TProps) {
  return (
    <StyledButton
      image={zoomImg as string}
      hoverImage={zoomHoverImg as string}
      onClick={props.onClick}
    >
      Zoom
    </StyledButton>
  );
}

export default Zoom;
